"use client";

import { LucideIcon } from "lucide-react";
import { CompletionBadge } from "@/components/common/CompletionBadge";
import { Typography } from "./Typography";
import { cn } from "@/lib/utils/cn";

export interface CardHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  isComplete?: boolean;
  actions?: React.ReactNode;
  className?: string;
}

export function CardHeader({
  icon: Icon,
  title,
  subtitle,
  isComplete,
  actions,
  className,
}: CardHeaderProps) {
  return (
    <div
      className={cn(
        "flex items-center flex-wrap gap-y-2 justify-between px-4 py-3 bg-gray-50 border-b border-gray-200",
        className,
      )}
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <div className="flex items-center justify-center w-7 h-7 rounded-md bg-navigator-primary/10">
          <Icon className="w-4 h-4 text-navigator-primary" />
        </div>
        <div className="min-w-0">
          <Typography as="h4" variant="body" weight="semibold">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="small" color="light" truncate className="max-w-xs">
              {subtitle}
            </Typography>
          )}
        </div>
      </div>
      {(isComplete !== undefined || actions) && (
        <div className="flex items-center gap-3">
          {isComplete !== undefined && (
            <CompletionBadge isComplete={isComplete} size="sm" />
          )}
          {actions}
        </div>
      )}
    </div>
  );
}
